module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C508"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "C509"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/05_Preface#page_ix"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "C509"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_1__Prologue__What_This_Book_Is_A#page_1"
    }
  }, [_vm._v("1: Prologue: What This Book Is About")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_1__Prologue__What_This_Book_Is_A#id_1"
    }
  }, [_vm._v("1.1 Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_1__Prologue__What_This_Book_Is_A#id_2"
    }
  }, [_vm._v("1.2 Where We Begin")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_1__Prologue__What_This_Book_Is_A#id_3"
    }
  }, [_vm._v("1.3 What Vectors Are Not")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_1__Prologue__What_This_Book_Is_A#id_4"
    }
  }, [_vm._v("1.4 What Traditional Vectors Are")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_1__Prologue__What_This_Book_Is_A#id_5"
    }
  }, [_vm._v("1.5 Do Vectors Have a Location?")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_1__Prologue__What_This_Book_Is_A#id_6"
    }
  }, [_vm._v("1.6 Coordinate Transformations "), _c('em', [_vm._v("vs")]), _vm._v(" Distortions of System")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_1__Prologue__What_This_Book_Is_A#id_7"
    }
  }, [_vm._v("1.7 Why Is Topological Invariance Important?")])]), _vm._v(" "), _c('p', {
    staticClass: "C654"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_1__Prologue__What_This_Book_Is_A#id_8"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "C509"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_2__Vector_Types_and_Vector_Opera#page_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2: Vector Types and Vector Operations")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_2__Vector_Types_and_Vector_Opera#id_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.1 What Is the Problem?")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_2__Vector_Types_and_Vector_Opera#id_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.2 Stacks")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_2__Vector_Types_and_Vector_Opera#id_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.3 The Size of Mathematical Objects")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_2__Vector_Types_and_Vector_Opera#page_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.4 Orientation of Lines and of Planes")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_2__Vector_Types_and_Vector_Opera#id_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.5 Algebra of Arrows and of Stacks")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_2__Vector_Types_and_Vector_Opera#id_13",
      "id": "page_vi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.6 The Dot Product")])]), _vm._v(" "), _c('p', {
    staticClass: "C654"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_2__Vector_Types_and_Vector_Opera#id_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "C509"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_3__More_Operations__More_Vectors#page_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3: More Operations, More Vectors")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_3__More_Operations__More_Vectors#id_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.1 A New Kind of Product")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_3__More_Operations__More_Vectors#id_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.2 The Cross Product of Arrows")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_3__More_Operations__More_Vectors#id_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.3 Polar and Axial Sense Genders")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_3__More_Operations__More_Vectors#id_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.4 Algebra of Polar and Axial Senses")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_3__More_Operations__More_Vectors#id_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.5 Polar and Axial Scalars")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_3__More_Operations__More_Vectors#id_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.6 The Fourth and Last Vector: The Sheaf")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_3__More_Operations__More_Vectors#id_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.7 Algebra of Thumbtacks and Sheaves")])]), _vm._v(" "), _c('p', {
    staticClass: "C654"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_3__More_Operations__More_Vectors#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "C509"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_4__Completion_of_the_Menagerie#page_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4: Completion of the Menagerie")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_4__Completion_of_the_Menagerie#id_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.1 Reprise: The Need for Invariance")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_4__Completion_of_the_Menagerie#id_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.2 What Is Still Missing")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_4__Completion_of_the_Menagerie#id_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.3 The Remaining Cross Products")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_4__Completion_of_the_Menagerie#id_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.4 More Dot Products: Scalar Densities and Capacities")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_4__Completion_of_the_Menagerie#id_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.5 Formalization of Nomenclature")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_4__Completion_of_the_Menagerie#id_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.6 The Geometrical Meaning of “Co-” and “Contra-”")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_4__Completion_of_the_Menagerie#page_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.7 Multiplication by Scalar Densities and Capacities")])]), _vm._v(" "), _c('p', {
    staticClass: "C654"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_4__Completion_of_the_Menagerie#id_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "C509"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_5__Fields_and_the_Geometrical_Ca#page_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5: Fields and the Geometrical Calculus")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_5__Fields_and_the_Geometrical_Ca#id_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.1 Fields")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_5__Fields_and_the_Geometrical_Ca#id_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.2 The Gradient")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_5__Fields_and_the_Geometrical_Ca#id_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.3 The Curl")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_5__Fields_and_the_Geometrical_Ca#id_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.4 The Divergence")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_5__Fields_and_the_Geometrical_Ca#id_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.5 The Inverse Operations")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_5__Fields_and_the_Geometrical_Ca#page_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.6 The Meaning of Differential Operations")])]), _vm._v(" "), _c('p', {
    staticClass: "C654"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_5__Fields_and_the_Geometrical_Ca#page_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "C509"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_6__Coordinates_and_Components#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6: Coordinates and Components")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_6__Coordinates_and_Components#id_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.1 Coordinate Systems")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_6__Coordinates_and_Components#id_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.2 The Bases of Scalar Capacities and Densities")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_6__Coordinates_and_Components#page_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.3 The Arrow and Stack Bases")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_6__Coordinates_and_Components#id_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.4 Stack-Arrow Dot Product in Terms of Components")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_6__Coordinates_and_Components#page_74",
      "id": "page_vii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.5 How Coordinate Systems Differ")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_6__Coordinates_and_Components#id_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.6 But Off the Record, How Does It Look?")])]), _vm._v(" "), _c('p', {
    staticClass: "C654"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_6__Coordinates_and_Components#id_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "C509"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_7__The_Grand_Algebraization_Rule#page_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7: The Grand Algebraization Rule")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_7__The_Grand_Algebraization_Rule#id_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.1 Statement of the Rule")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_7__The_Grand_Algebraization_Rule#id_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.2 The Remaining Bases")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_7__The_Grand_Algebraization_Rule#id_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.3 Cross Products in Terms of Components")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_7__The_Grand_Algebraization_Rule#id_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.4 Hermaphrodite Sense Gender of the Bases")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_7__The_Grand_Algebraization_Rule#id_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.5 Computation of the Gradient")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_7__The_Grand_Algebraization_Rule#id_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.6 Computation of the Curl")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_7__The_Grand_Algebraization_Rule#id_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.7 And Finally, the Divergence")])]), _vm._v(" "), _c('p', {
    staticClass: "C654"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_7__The_Grand_Algebraization_Rule#id_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "C509"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_8__Goodbye_to_the_Rubber_Univers#page_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8: Goodbye to the Rubber Universe")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_8__Goodbye_to_the_Rubber_Univers#id_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.1 The Need for Measurement")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_8__Goodbye_to_the_Rubber_Univers#id_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.2 Example: The Electromagnetic Field")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_8__Goodbye_to_the_Rubber_Univers#id_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.3 Underlying Cartesian System")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_8__Goodbye_to_the_Rubber_Univers#id_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.4 Legalization of Illegal Operations; the Laplacian")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_8__Goodbye_to_the_Rubber_Univers#id_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.5 The “Del” Operator")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_8__Goodbye_to_the_Rubber_Univers#id_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.6 Orthogonal Systems")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_8__Goodbye_to_the_Rubber_Univers#id_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.7 The Metric")])]), _vm._v(" "), _c('p', {
    staticClass: "C654"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_8__Goodbye_to_the_Rubber_Univers#page_105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "C509"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_9__Epilogue__Where_This_Book_Lea#page_107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9: Epilogue: Where This Book Leaves Us")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_9__Epilogue__Where_This_Book_Lea#id_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.1 Some Remaining Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_9__Epilogue__Where_This_Book_Lea#id_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.2 Number of Dimensions")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_9__Epilogue__Where_This_Book_Lea#id_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.3 Curved Spaces")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_9__Epilogue__Where_This_Book_Lea#id_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.4 Indefinite Metric")])]), _vm._v(" "), _c('p', {
    staticClass: "C651"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_9__Epilogue__Where_This_Book_Lea#id_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.5 The Nature of Tensor Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "C652"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_9__Epilogue__Where_This_Book_Lea#id_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.6 Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "C509"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_Index#page_113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f7f2103","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_CONTENTS.vue
// module id = 66
// module chunks = 0